export default "__VITE_ASSET__DwcTmghE__"